const theme = {
  colors: {
    white: "#FFF",
    lightGreen: "#F0F5EA",
    darkGreen: "#273618",
    primaryGreen: "#74A048",
    bg: "#FFFFFA",
    black: "#333333",
    red: "#E43849",
  },

  fontSizes: {
    extraSmall: "0.8rem",
    small: "1rem",
    normal: "1.2rem",
    medium: "1.5rem",
    large: "2rem",
    extraLarge: "3rem",
    big: "5rem",
    btn: "1.2rem",
  },

  fontWeights: {
    light: 300,
    normal: 400,
    bold: 700,
  },

  margins: {
    extraSmall: "0.5rem",
    small: "1rem",
    normal: "1.5rem",
    medium: "2rem",
    large: "3rem",
    extraLarge: "5rem",
    big: "7rem",
  },

  borderRadius: {
    small: "8px",
    medium: "25px",
    circle: "50%",
  },

  width: {
    mobile: "576px",
    tablet: "768px",
    desktop: "1280px",
    large: "1600px",
  },

  transitions: {
    normal: "all 0.2s ease-in-out",
    medium: "all 0.4s ease-in-out",
  },
};

export default theme;
